/* (SYNC) */
export const RESET_DETAIL_FATIGUE = 'RESET_DETAIL_FATIGUE';
export const SET_FILTER_DETAIL_FATIGUE = 'SET_FILTER_DETAIL_FATIGUE';

/* (ASYNC) */
export const FETCH_DETAIL_FATIGUE_INIT = 'FETCH_DETAIL_FATIGUE_INIT';
export const FETCH_DETAIL_FATIGUE_SUCCESS = 'FETCH_DETAIL_FATIGUE_SUCCESS';
export const FETCH_DETAIL_FATIGUE_FAILURE = 'FETCH_DETAIL_FATIGUE_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/detail_fatigue/types.js